import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';

interface ItemHierarchy {
  itemValue: string;
  itemId: string;
  domaineId: string;
  matiereId: string;
  programmationId: string;
}

function getProgrammationItem(
  itemId: string,
  schoolId: string,
  schoolyearId: string,
): Promise<ItemHierarchy> {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/programmations-items/${itemId}`;
  return request(requestURL, {
    method: 'GET',
  });
}

const PROGRAMMATION_ITEM_HIERARCHY_KEY = 'PROGRAMMATION_ITEM_HIERARCHY';

export function useProgrammationItemHierarchy({ itemId }: { itemId: string }) {
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery({
    queryKey: [
      schoolyear.id,
      school.id,
      PROGRAMMATION_ITEM_HIERARCHY_KEY,
      itemId,
    ],
    queryFn: () => getProgrammationItem(itemId, school.id, schoolyear.id),
    refetchOnWindowFocus: false,
  });
}
